import React, { useEffect, useState } from 'react';
import ExportExtentionForm from '@app/components/apps/Export/ExportExtention/ExportExtentionForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreateExportExtension: React.FC = () => {
  const [currentBreadcrumbName, setCurrentBreadcrumbName] = useState<string>('Add Export-Extensions');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/export-extensions',
      breadcrumbName: 'Export-Extensions',
    },
    {
      path: '/add-export-extension',
      breadcrumbName: currentBreadcrumbName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumbName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportExtentionForm
            type="create"
            setCurrentBreadcrumName={setCurrentBreadcrumbName}
            pageTitle={'Create Export-Extension'}
            editable={true}
            id={undefined}
          />
        </Col>
      </Row>
    </>
  );
};

export default CreateExportExtension;
